<template>
  <section class="leap-year-hero">
    <div
      :class="['leap-year-hero__content', isLeapYearPromoPage && 'leap-year-hero__content--mt-10']"
    >
      <div class="leap-year-hero__title">
        <h1 class="leap-year-hero__title-maintitle">LEAP YEAR</h1>
        <h2 class="leap-year-hero__title-subtitle">SAVINGS ARE HERE</h2>
      </div>
      <div class="leap-year-hero__intro-wrapper">
        <div class="leap-year-hero__intro">Leap into your new training program.</div>
        <div class="leap-year-hero__text">
          Pick the perfect training promotion to match with your upskilling needs - for individual
          learners!
        </div>
      </div>
      <div v-if="!isLeapYearPromoPage" class="leap-year-hero__learn-more">
        <router-link :to="{ name: 'leap-year-2024' }" class="btn btn--primary btn--full-mobile">
          Shop savings
        </router-link>
      </div>
    </div>
    <div class="leap-year-hero__icon">
      <div class="leap-year-hero__icon-logo-wrapper">
        <img
          :src="leapYearCircleLogoBadge"
          alt="Leap Year Promo - Choose your adventure"
          class="leap-year-hero__icon-logo-circle"
        />
        <LYLogoSVG class="leap-year-hero__icon-logo-text" />
      </div>
    </div>
  </section>
</template>

<script>
import LYLogoSVG from '@/assets/images/hero-section/leap-year/ly-logo.svg'
import LYCircleLogo from '@/assets/images/hero-section/neon-circle-logo.png'
import { routesRules } from '@/helpers/mixins'

export default {
  name: 'LeapYearPromoHeroSection',
  mixins: [routesRules],
  components: {
    LYLogoSVG: { ...LYLogoSVG, name: 'LYLogoSVG' },
  },
  data() {
    return {
      leapYearCircleLogoBadge: LYCircleLogo,
    }
  },
}
</script>

<style lang="scss" scoped>
.leap-year-hero {
  width: 100%;
  max-width: 1120px;
  color: var(--white);
  font-family: var(--font-regular);
  display: flex;
  flex-flow: column-reverse;
  position: relative;
  padding: 0 20px 20px 20px;
  @include mobile {
    flex-flow: row;
  }
  @include desktop {
    flex-flow: row;
    margin: auto;
    padding: 50px 0;
  }
  &__title {
    &-maintitle {
      color: var(--white);
      font-family: var(--font-medium);
      font-size: rem(35px);
      font-style: normal;
      font-weight: 900;
      line-height: rem(37px);
      margin: 0;
      @include mobile {
        font-size: rem(40px);
      }
      @include desktop {
        font-size: rem(72px);
        line-height: rem(50px);
      }
    }
    &-subtitle {
      color: var(--brilliant-rose);
      font-size: rem(35px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(37px);
      margin: 0;
      @include mobile {
        font-size: rem(40px);
      }
      @include desktop {
        font-size: rem(54px);
        line-height: rem(50px);
      }
    }
  }
  &__intro {
    font-size: rem(17px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(26px);
    @include desktop {
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__text {
    color: var(--light-blue-gray);
    font-size: rem(17px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(26px);
    width: 75%;
    @include mobile {
      width: 90%;
    }
    @include desktop {
      width: 60%;
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__content {
    display: flex;
    flex-flow: column;
    gap: 20px;
    @include mobile {
      margin-top: 70px;
    }
    &--mt-10 {
    }
  }
  &__icon {
    margin-bottom: 30px;
    @include mobile {
      margin-bottom: 0;
      margin-top: 15px;
    }
    &-logo-wrapper {
      position: relative;
      width: 220px;
      height: 220px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      @include mobile {
        width: 290px;
        height: 290px;
      }
      @include desktop {
        width: 445px;
        height: 415px;
      }
    }
    &-logo-text {
      position: absolute;
      top: -72px;
      width: 440px;
      height: 363px;
      transform: scale(0.53);
      @include mobile {
        top: -40px;
        transform: scale(0.7);
      }
      @include desktop {
        top: 25px;
        transform: scale(1);
      }
    }
    &-logo-circle {
      transform: rotate(0deg);
      animation: spin 50s linear infinite;
    }
  }
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
